/**
 * @module
 *
 * @import {Portal} from '../ts/core/portal';
 */

import {BOOLEAN, guard, INTEGER, NULLABLE, OBJECT, STRING} from '@acng/frontend-rubicon';
import {parseScriptElementAsJson} from '@acng/frontend-bounty/parse.js';
import {extend} from '@acng/frontend-bounty/object.js';
import {FSK_LEVEL} from './model/fsk.js';
import {HrefMailTo} from '../layout/node/email.js';

const EMAIL = /* @__PURE__ */ OBJECT({
  support: STRING,
  compliance: STRING,
});

const LINK = /* @__PURE__ */ OBJECT({
  creator: STRING,
  webmaster: NULLABLE(STRING),
});

const PORTAL = /* @__PURE__ */ OBJECT({
  id: INTEGER,
  name: STRING,
  shortcut: STRING,
  mobile: BOOLEAN,
  niche: STRING,
  list_sorting_suffix: STRING,
  is_international: BOOLEAN,
  email: EMAIL,
  link: LINK,
  guest_fsk: FSK_LEVEL,
  list_base_fsk: FSK_LEVEL,
  copyrightNotice: STRING,
  script: /* @__PURE__ */ OBJECT({
    matomo: /* @__PURE__ */ NULLABLE(STRING),
  }),
  fsk: /* @__PURE__ */ OBJECT({
    disclaimer: BOOLEAN,
  }),
});

const data = parseScriptElementAsJson('portal');
ASSERT: guard(data, PORTAL, 'webpage portal data');

/**
 * @type {Portal}
 */
const portal = {
  // Do not extend but spread, because angularjs does not recognize inherited properties.
  ...data,
  abbr: data.shortcut.toLowerCase(),
  mailto: {
    support: HrefMailTo(data.email.support),
    compliance: HrefMailTo(data.email.compliance),
  },
  flag: {
    international: data.is_international,
    domestic: !data.is_international,
  },
};

export {portal};
